import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterType, ResultsDatum, ResultsDatumUI } from 'src/app/features/secured-skeleton/models/global-search';

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss'],
  standalone: false,
})
export class SearchResultComponent implements OnInit {
  @Input() item: ResultsDatumUI;
  @Input() serviceAddon: string;
  @Output() onResultClickedEmitter = new EventEmitter<ResultsDatum>();

  resultIconUI: string;
  resultTextUI: string;

  constructor() {}

  ngOnInit(): void {
    this.resultIconUI = this.renderResultIcon(this.item.resultType);
    this.resultTextUI = this.renderResultText(this.item.resultType);
  }

  renderResultIcon(resultType: FilterType): string {
    switch (resultType) {
      case 'cpo':
        return 'icon_search-purchase-order';
      case 'ticket-number':
        return 'icon_search-ticket-number';
      case 'serial-numbers':
        return 'icon_search-serial-num';
      case 'tracking-numbers':
        return 'icon_search-tracking-num';
      case 'asset-tag':
        return 'icon_search-asset-tag';
      case 'customer-ticket-number':
        return 'icon_search-customer-ticket-num';
      default:
        return 'Unknown';
    }
  }

  renderResultText(resultType: FilterType): string {
    switch (resultType) {
      case 'cpo':
        return 'PURCHASE ORDER';
      case 'ticket-number':
        return 'TICKET NUMBER';
      case 'serial-numbers':
        return 'SERIAL NUMBER';
      case 'tracking-numbers':
        return 'TRACKING NUMBER';
      case 'asset-tag':
        return 'ASSET TAG';
      case 'customer-ticket-number':
        return 'CUSTOMER TICKET NUMBER';
      default:
        return 'Unknown';
    }
  }

  onResultClicked() {
    this.onResultClickedEmitter.emit(this.item);
  }
}
